import { styled } from "@linaria/react";
import { useRouter } from "next/router";
import { useEffect } from "react"; // eslint-disable-next-line @typescript-eslint/no-var-requires

const Logo = require("./logo.svg"); // eslint-disable-next-line @typescript-eslint/no-var-requires


const Hamburger = require("./hamburger.svg");

import { logEvent } from "../../utils";
import { COLOR_BLACK, COLOR_BLUE_LIGHTER, COLOR_RED, SIZE_M } from "../../constants";
import ActiveLink from "../activeLink";
import { useState, useRef } from "react";
import { css } from "@linaria/core";
import { TwitterIcon } from "../icons";
const Nav = /*#__PURE__*/styled("nav")({
  name: "Nav",
  class: "n1sho5uq"
});
const Home = /*#__PURE__*/styled("a")({
  name: "Home",
  class: "h1itfd1"
});
const HamburgerButton = /*#__PURE__*/styled("button")({
  name: "HamburgerButton",
  class: "h2b41j7"
});
const NavList = /*#__PURE__*/styled("ul")({
  name: "NavList",
  class: "n1bxwq6b"
});
const NavListItem = /*#__PURE__*/styled("li")({
  name: "NavListItem",
  class: "nm3vqa5"
});
const NavListItemLink = /*#__PURE__*/styled("a")({
  name: "NavListItemLink",
  class: "n1rb6698"
});
const NavListItemLinkAnchor = /*#__PURE__*/styled(NavListItemLink)({
  name: "NavListItemLinkAnchor",
  class: "n12jgxfg"
});
const EmphasisDot = "ed7j27s";
const SvgAnchor = /*#__PURE__*/styled("a")({
  name: "SvgAnchor",
  class: "s1pb51ke"
});
const svgStyle = "s6ibibc";
const mobileOnly = "m1g0bvqx";
const mediumUp = "mg9895w";

function Navigation(): JSX.Element {
  const [burgerOpen, setBurgerOpen] = useState(false);
  const {
    pathname
  } = useRouter();
  const navRef = useRef<HTMLElement | null>(null);
  useEffect(() => {
    setBurgerOpen(false);
  }, [pathname, setBurgerOpen]);
  useEffect(() => {
    if (!burgerOpen) {
      return;
    }

    function handleClickOutside(event: MouseEvent) {
      if (navRef.current && !navRef.current.contains((event.target as Node))) {
        setBurgerOpen(false);
      }
    } // Bind the event listener


    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navRef, setBurgerOpen, burgerOpen]);
  return <Nav ref={navRef}>
      <ActiveLink href="/" passHref>
        <Home>
          <Logo />
        </Home>
      </ActiveLink>
      <div>
        <HamburgerButton className={burgerOpen ? "open" : ""} onClick={() => setBurgerOpen(!burgerOpen)}>
          <Hamburger />
        </HamburgerButton>
        <NavList className={burgerOpen ? "open" : ""}>
        <NavListItem className="navigation_item">
            <ActiveLink href="https://changelog.fiberplane.com/?utm_source=homepage" passHref>
              <NavListItemLinkAnchor>Changelog</NavListItemLinkAnchor>
            </ActiveLink>
          </NavListItem>
          <NavListItem className="navigation_item">
            <ActiveLink href="/blog" passHref>
              <NavListItemLinkAnchor>Blog</NavListItemLinkAnchor>
            </ActiveLink>
          </NavListItem>
          <NavListItem className="navigation_item">
            <ActiveLink href="/about" passHref>
              <NavListItemLinkAnchor>About</NavListItemLinkAnchor>
            </ActiveLink>
          </NavListItem>
          <NavListItem className="navigation_item">
            <ActiveLink href="/careers" passHref>
              <NavListItemLinkAnchor className={EmphasisDot}>
                Careers
              </NavListItemLinkAnchor>
            </ActiveLink>
          </NavListItem>
          <NavListItem>
            <SvgAnchor href="https://twitter.com/fiberplane" className={mediumUp}>
              <TwitterIcon className={svgStyle} alt="Twitter" width="25" />
            </SvgAnchor>
            <NavListItemLinkAnchor href="https://twitter.com/fiberplane" onClick={event => {
            event.preventDefault();
            logEvent("button:click", "twitter", "top-menu");
            const url = event.currentTarget.getAttribute("href");

            if (url) {
              setTimeout(() => window.location.href = url, 100);
            }
          }} className={mobileOnly}>
              Twitter
            </NavListItemLinkAnchor>
          </NavListItem>
        </NavList>
      </div>
    </Nav>;
}

export default Navigation;

require("../../../.linaria-cache/src/components/navigation/index.linaria.module.css");